/**
 * Excepciones de menú para Naomi Sarai Palma Mendez (iderp 2781).
 * - RH: Solicitar Cambio Horario
 * - Marketing: Acceso a CRM's
 */
export const IDERP_NAOMI_PALMA = 2781

const ACCIONES = [
  {
    idmenu: 6,
    menuTitle: 'RH',
    path: 'CambioHorario',
    title: 'Solicitar Cambio Horario',
    icon: 'mdi mdi-circle-medium theme--light',
  },
  {
    idmenu: 9,
    menuTitle: 'Marketing',
    path: 'AccesoCRM',
    title: "Acceso a CRM's",
    icon: 'mdi mdi-circle-medium theme--light',
  },
]

function menuTienePath(menu, path) {
  if (!Array.isArray(menu)) return false
  for (const top of menu) {
    for (const cat of top.items || []) {
      if (cat && cat.path === path) return true
      for (const child of cat.items || []) {
        if (child && child.path === path) return true
      }
    }
  }
  return false
}

export function esAccesoMenuNaomi(iderp) {
  return Number(iderp) === IDERP_NAOMI_PALMA
}

/**
 * Inyecta las acciones de Naomi si aún no están en el menú del puesto.
 */
export function asegurarMenuNaomiPalma(menu, iderp) {
  if (!esAccesoMenuNaomi(iderp)) {
    return Array.isArray(menu) ? menu : []
  }

  const list = Array.isArray(menu) ? menu : []

  for (const a of ACCIONES) {
    if (menuTienePath(list, a.path)) continue

    let target = list.find((m) => Number(m.idmenu) === a.idmenu)
    if (!target) {
      target = {
        title: a.menuTitle,
        idmenu: a.idmenu,
        path: null,
        items: [],
      }
      list.push(target)
    }
    if (!Array.isArray(target.items)) target.items = []

    target.items.push({
      title: a.title,
      path: a.path,
      icon: a.icon,
      active: 1,
    })
  }

  return list
}
